import { Butticon } from '@hopin-team/ui-butticon';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { Menu } from '@hopin-team/ui-menu';
import styled from 'styled-components';

export const AddToCalendarMenu = styled(Menu)`
  z-index: 1;
`;

export const StyledButticon = styled(Butticon)`
  background-color: ${({ theme }) => getFromTheme(`COLOR.GREY.WHITE`, theme)};
`;
